import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'drag-drop-touch';

import App from './App';
import './styles/index.scss';

Sentry.init({
  dsn: 'https://a5cd9ad8d15e91d2db6ca012fbd5fb0c@sentry.finch.fm/108',
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
